document.addEventListener('DOMContentLoaded', function () {
  const USER_ID = '17841400125469092';
  const ACCESS_TOKEN = 'EAAOAiVnG2pcBAJnZBwQBb4HtpDyc77FK39ZA2yoMTg8j6ZAwT9blbMxfioxgzPhzTTqucgDuofVjaaiE98KgtFHguqBlSQFJhV66aamZAFJgVfAIUO4cUAJccC2Y8rDV0YY386p2BvvRZACrpfEMjYDnPTk25lxeA8rfqionfsC8peSMHPF9E';
  const FIELDS = 'name,media.limit(36){caption,like_count,media_url,permalink,timestamp,username}';
  const API_VERSION = 'v21.0';

  const url = `https://graph.facebook.com/${API_VERSION}/${USER_ID}?fields=${encodeURIComponent(FIELDS)}&access_token=${ACCESS_TOKEN}`;

  fetch(url)
    .then(response => response.json())
    .then(json => {
      const feed = document.getElementById('instafeed');
      if (!feed || !json.media) return;

      const html = json.media.data.map(item =>
        `<li><a href="${item.permalink}" target="_blank"><img src="${item.media_url}" alt="${item.caption || ''}"></a></li>`
      ).join('');

      feed.insertAdjacentHTML('beforeend', html);
    })
    .catch(err => {
      console.error('Instagram feed error:', err);
    });
});
